<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
      <span slot="left">
        <a-button @click="handleCreateBank" type="primary" class="button-color-cyan">新增银行</a-button>
      </span>
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleUpdate(record)">更新</a>
        <!--        <a-divider type="vertical" />-->
       </span>
    </BTable>
    <CreateBank
      ref="createBank"
      title="新增银行"
      :bank-list="bankList"
      @success="() => { this.$refs.table.refresh(true) }"
    ></CreateBank>
    <UpdateBank
      ref="updateBank"
      title="更新银行"
      :item="modifyItem"
      :bank-list="bankList"
      @success="() => { this.$refs.table.refresh(false) }"
    ></UpdateBank>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Bank',
  components: {
    CreateBank: () => import('./components/CreateBank'),
    UpdateBank: () => import('./components/UpdateBank')
  },
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = {
          ...this.queryParam
        }
        return this.$http.business.vaBankQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '银行',
          key: 'bankCode',
          type: 'select',
          options: [],
          optionKey: 'bankCode',
          optionValue: 'bankName'
        }
      ],
      changeLoading: false,
      columns: Object.freeze([
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '银行代码',
          dataIndex: 'bankCode' // no
        },
        {
          title: '银行名称',
          dataIndex: 'bankName'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: 'swift code',
          dataIndex: 'swiftCode'
          // needTotal: true
        },
        {
          title: '最小位数', // 请求接口？
          dataIndex: 'min'
        },
        {
          title: '最大位数',
          dataIndex: 'max'
          // customRender: () => '没有'
        },
        {
          title: '账号前缀',
          dataIndex: 'bankPrefix'
        },
        {
          title: '账户名前缀',
          dataIndex: 'accountNamePrefix'
        },
        {
          title: '索引',
          dataIndex: 'accountIndex'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]),
      modifyItem: {},
      bankList: []
    }
  },
  async created () {
    await this.getQueryParams()
  },
  methods: {
    async getQueryParams () {
      const params = { request: {} }
      try {
        const currencyRes = await this.$http.business.vaBankAvailableQueryList(params)
        // bankList
        const { data: bankList } = currencyRes
        const bankSelect = this.searchList[0]
        this.bankList = bankList
        this.$set(this.searchList, 0, Object.assign({}, bankSelect, { options: bankList }))
      } catch (e) {
        // console.log(e)
      }
    },
    handleUpdate (item) {
      this.modifyItem = item
      this.$refs.updateBank.visible = true
    },
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    },
    handleCreateBank () {
      this.$refs.createBank.visible = true
    }
  }
}
</script>

<style scoped lang="less">
</style>
